import React, {useEffect, useState} from 'react'
import { Display } from '../Main/styles'
import { StatusHeader, StatusHeaderBtn, StatusHeaderTitle, StatusWrapper } from '../Status/styles'
import { Table, message } from 'antd';
import { usePlatformList } from 'CRM/hooks/GetPlatformList';
import PlatformEdit from 'CRM/components/Edit/PlatformEdit';
import PlatformAdd from 'CRM/components/Add/PlatformAdd';
import { useToken } from 'app/hooks';
import API from 'utils/api';
import {useIsMobile} from "../../components/IsMobile";

export const Platform = () => {
  const IsMobile = useIsMobile();
  const [scrollPosition, setScrollPosition] = useState(0);
  const { data: token } = useToken();
  const { platformList, mutate } = usePlatformList();
  const [isEdit, setIsEdit] = useState(false);
  const [isAdd, setIsAdd] = useState(false);
  const [data, setData] = useState();


  useEffect(() => {
    if(!isEdit && IsMobile){
      window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
    } else if(isEdit && IsMobile) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setScrollPosition(window.scrollY);
    }
  }, [isEdit]);

  const deleteStatus = (data) => {
    const shouldEdit = window.confirm(`정말 ${data?.name}을 삭제하시겠습니까?`);
    if(shouldEdit) {
      API.delete('/system/platform/' + data?.id, token + '', {})
      .then((res: any) => {
        if (res.result.success) {
          message.success('삭제되었습니다');
          mutate();
        }
      })
      .catch((err: any) => {})
    }
  }

  const mobileColumns = [
    {
      dataIndex: '',
      title: '플랫폼',
      render: (value, data) => {
        return (
          <>
            <div className='date' style={{justifyContent: 'flex-start', display: 'flex'}}><p style={{marginRight: 5, fontWeight: 'bold'}}>등록일: </p>  {data?.createdAt || '-'}</div>
            <div className='name' style={{justifyContent: 'flex-start', display: 'flex'}}><p style={{marginRight: 5, fontWeight: 'bold'}}>플랫폼명: </p>  {data?.name  || '-'}</div>
            <div className='desc' style={{justifyContent: 'flex-start', display: 'flex'}}><p style={{marginRight: 5, fontWeight: 'bold'}}>설명: </p>  {data?.desc || '-'}</div>
            <div className='date' style={{justifyContent: 'flex-start', display: 'flex'}}><p style={{marginRight: 5, fontWeight: 'bold'}}>수정일: </p>  {data?.updatedAt || '-'}</div>
            <div className='btns' style={{justifyContent: 'flex-start', display: 'flex'}}>
              <button className='edit' onClick={() => {setIsEdit(true); setData(data);}}>수정</button>
              <button className='delete' onClick={() => deleteStatus(data)}>삭제</button>
            </div>
          </>
        )
      }
    },
  ]

  const columns = [
    {
      dataIndex: '',
      title: '등록일',
      render: (value, data) => {
        return (
          <div className='date'>{data?.createdAt}</div>
        )
      }
    },
    {
      dataIndex: '',
      title: '플랫폼명',
      render: (value, data) => {
        return (
          <div className='name'>{data?.name}</div>
        )
      }
    },
    {
      dataIndex: '',
      title: '설명',
      render: (value, data) => {
        return (
          <div className='desc'>{data?.desc == null || '' ? '-' : data?.desc}</div>
        )
      }
    },
    {
      dataIndex: '',
      title: '수정일',
      render: (value, data) => {
        return (
          <div className='date'>{data?.updatedAt}</div>
        )
      }
    },
    {
      dataIndex: '',
      title: '변경',
      render: (value, data) => {
        return (
          <div className='btns'>
            <button className='edit' onClick={() => {setIsEdit(true); setData(data);}}>수정</button>
            <button className='delete' onClick={() => deleteStatus(data)}>삭제</button>
          </div>
        )
      }
    },
  ];

  return (
    <Display IsMobile={IsMobile}>
      <StatusWrapper>
        <StatusHeader>
          <StatusHeaderTitle>플랫폼관리</StatusHeaderTitle>
          <StatusHeaderBtn onClick={() => setIsAdd(true)}>추가</StatusHeaderBtn>
        </StatusHeader>
        <Table dataSource={platformList} columns={ IsMobile ? mobileColumns : columns} />
      </StatusWrapper>
      {isEdit && <PlatformEdit setIsEdit={setIsEdit} data={data} />}
      {isAdd && <PlatformAdd setIsAdd={setIsAdd} />}
    </Display>
  )
}

export default React.memo(Platform);